<template>
  <div class="all-work__main">
    <div class="all-work__block">
      <h1 class="all-work__title">{{ $t("message.Works") }}</h1>
      <p class="all-work__text" v-if="worksTotal>0">
        {{ $tc("message.works_plural_0125", worksTotal) }}
      </p>
    </div>

    <on-map :is_mark_work_pro="false" theme="air_light"/>
  </div>
</template>

<script>
  import onMap from "../../../components/list/filter/onMap";
  import NavBarArtistGalleryMix from "../../../components/NavBarArtistGalleryMix";
  import WorksComputedMix from "../../../components/WorksComputedMix";

  export default {
    components: {onMap},
    name      : 'nav-bar-artist-gallery-sub',
    mixins: [NavBarArtistGalleryMix, WorksComputedMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/NavBarArtistGallerySub.vue